// extracted by mini-css-extract-plugin
export default {"basketCard":"basketCard__2T5u7","basketCardContent":"basketCardContent__2dF5g","price":"price__2es8C","totalTitle":"totalTitle__rLBv6","footerPaymentContainer":"footerPaymentContainer__1LHWk","footerPaiement":"footerPaiement__Qi5ix"};
    if(module.hot) {
      // 1790586286530
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  